import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { CodeBuilderField } from '../components/CodeBuilder';
import {
  codeBuilderUiOptionsSchema,
  codeBuilderValueSchema,
} from '../schemas/codeBuilderSchema';

export const codeBuilderFieldExtension: any = FormFieldBlueprint.make({
  name: 'code-builder',
  params: {
    field: async () =>
      createFormField({
        name: 'CodeBuilder',
        component: CodeBuilderField,
        schema: makeFieldSchema({
          output: () => codeBuilderValueSchema,
          uiOptions: () => codeBuilderUiOptionsSchema,
        }),
      }),
  },
});
